import React from 'react';
import {SmallSecondaryButton, TagBlue} from '@worthy-npm/clarity';
import { Grid } from '@material-ui/core';

import { LOCAL_STORAGE_PREFIX, RDStorage, FILTERS_PER_TYPE } from './filtersData';

import { isMobile, isTablet } from '../filters/filter_constants_and_helpers';
import { FILTER_OPTIONS } from "../filters/filter_constants_and_helpers.jsx.erb";
import CdnPath from "../../services/cdn_path";

class RecentDealsFilters extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            visible:!isMobile(),
            searchButtonHeight:33,
            changedFilters:{},
            hiddenFilters: false,
        }
        this.setFilters = this.setFilters.bind(this)
        this.renderXline = this.renderXline.bind(this)
        this.renderSearchButton = this.renderSearchButton.bind(this)
        this.toggleVisibility = this.toggleVisibility.bind(this)
        this.limitScrolling = this.limitScrolling.bind(this)
        this.clearAllFilters = this.clearAllFilters.bind(this)
        this.renderTagLine = this.renderTagLine.bind(this)
        this.renderFiltersAppliedLines = this.renderFiltersAppliedLines.bind(this)

        this.searchButtonRef = React.createRef()
        this.mainDiv = React.createRef()
    }

    componentDidUpdate(prevProps) {
        /*
        *  Logic for this solution described in RecentDealsDesktopFilters.jsx file.
        * */
        const itemsWithSameFilters = ['necklaces', 'earrings', 'bracelets', 'rings', 'loose-diamonds']; // items which has the same filters and didn`t update filters when change itemTpe in parent component

        if (prevProps.itemType !== this.props.itemType && itemsWithSameFilters.includes(this.props.itemType) && prevProps.itemType !== 'watches') {
            this.setState({
                hiddenFilters: true,
            });

            setTimeout(() => this.setState({ hiddenFilters: false }), 0);
        }
    }

    setFilters(filterName,newValue,isDefault,xClicked,tagName) {

        if (filterName === 'jewelry_brands') { // the same as for ResentDealsDesktopFilter
            const getNotInFilters = () => FILTER_OPTIONS.jewelry_brands.map(o => o.id);

            newValue.is && newValue.is.length >= 1 ? newValue.is = [null] : delete newValue.is; // in order to handle NULL records in bd
            newValue.not_in && newValue.not_in.length >= 1 ? newValue.not_in = getNotInFilters() : delete newValue.not_in;
        }

        this.props.onChangeFilter({ detail: { // for parent RecentDealsContainer component
                itemType: this.props.itemType,
                filterName: filterName,
                data: { ...newValue },
                tagNames: tagName,
                requiredFilters: FILTERS_PER_TYPE[this.props.itemType]
            }});

        // check if the current filter is different from it's default.
        let {changedFilters} = this.state;
        const { itemType } = this.props;

        if (!changedFilters[itemType]) {
            changedFilters[itemType] = {};
        }

        const filters = changedFilters[itemType];

        if ( isDefault ) {
            // when default value, we don't need the filter anymore in the state.
            delete filters[filterName]
        } else {
            filters[filterName] = newValue;
            filters[filterName].xClicked = xClicked;
            filters[filterName].tagName = tagName
        }

        this.setState({changedFilters})
    }

    toggleVisibility() {
        this.setState({visible:!this.state.visible})

        this.props.onChangeVisibility(!this.state.visible); // in order to parent be aware of state

        let selectorStr = "footer, .deals, #designstudio-button, #sharable,  .infiniteScroll"
        // when we toggle to visible, we want to limit scrolling to bottom of filters div.
        if ( !this.state.visible ) {
            $(selectorStr).hide()
        } else {
            $(selectorStr).show()
            window.scrollTo(0, 0);
        }
    }

    clearAllFilters() {
        const { itemType } = this.props;
        for (let changedFiltersKey in this.state.changedFilters[itemType]) {
            this.state.changedFilters[itemType][changedFiltersKey].xClicked()
        }
    }

    calcMainDivHeight() {
        let style = {
            paddingBottom:"24px",
            width: '100%',
        }
        if ( this.state.visible ) {
            // we want the minimum height of the filter div when open to take up the whole screen.
            let minHeight = window.innerHeight - this.mainDiv.current.offsetTop
            style.minHeight = minHeight+"px"
        }
        return style
    }

    limitScrolling() {
        let maxScroll = this.mainDiv.current.offsetTop + this.mainDiv.current.offsetHeight - window.innerHeight

        if($(window).scrollTop() > maxScroll) {
            $(document).scrollTop(maxScroll);
        }
    }

    renderTagLine() {
        const { changedFilters } = this.state;
        const filters = changedFilters[this.props.itemType];

        if ( Object.keys(filters || {}).length  == 0 ) {
            return
        }

        return (
            <div style={{paddingTop:"5px", textAlign: 'center'}} >
                {
                    Object.keys(filters).map(
                        (key) => filters[key].tagName.map(
                            tag =>
                                <span key={key+tag}  style={{ display: 'inline-block', margin: '0 10px 10px 0' }}>
                                    <TagBlue text={tag} onClose={() => filters[key].xClicked(tag)} />
                                </span>
                        )
                    )
                }
                <div className='clarity-button-wrapper' style={{display: 'inline-block'}}>
                    <SmallSecondaryButton
                        text="More filters"
                        click={this.toggleVisibility}
                        overrideCSS={{ color: '#2D5DEC', border: 'none', font: '400 14px Roboto'}}
                        overrideWrapperCSS={{backgroundColor: '#EAEFFF'}}
                    />
                </div>
            </div>)
    }

    renderFiltersAppliedLines() {
        const filters = this.state.changedFilters[this.props.itemType];

        let filterChanged = Object.keys(filters || {}).reduce((acc,cur) => {
           return acc + filters[cur].tagName.length
        },0)
        let filtersWord = filterChanged == 1 ? " filter" : " filters"
        return <div style={{ textAlign: 'center' }}>
            <span style={{paddingRight:"5px", font: '300 16px Roboto'}}>{ filterChanged + filtersWord + " applied  "}</span>
            { filterChanged == 0 ? null : 
                <div style={{display:"inline-block",color:"#2D5DEC",font: '400 14px Roboto'}} onClick={this.clearAllFilters}>Clear all</div>
            }
        </div>
    }

    renderSearchButton() {
        // we need to make the relative object take as much space as the absolute one.
        if (!isMobile()) {
            setTimeout(() => {
                if ( this.state.searchButtonHeight !== this.searchButtonRef.current.offsetHeight ) {
                    this.setState({searchButtonHeight:this.searchButtonRef.current.offsetHeight})
                }
            },0);
        }

        if (Object.keys(this.state.changedFilters[this.props.itemType] || {}).length > 0) {
            return null
        }

        return <div
            style={{
                position:"relative",
                height:this.state.searchButtonHeight+"px",
                textAlign: 'center'
            }}>
            <div ref={this.searchButtonRef} onClick={this.toggleVisibility}
                 style={{
                     display:"inline-block",
                     font: '400 16px Roboto',
                     cursor:"pointer",
                     paddingLeft:"28px",
                     backgroundImage:`url(${CdnPath("frontend/filters_icon.svg")})`,
                     backgroundPosition:"left",
                     backgroundRepeat:"no-repeat"}}>
                Filters
            </div>
        </div>
    }

    renderXline() {
        return <div style={{height:"33px",position:"relative",paddingBottom:isMobile() ? "30px" : "20px", margin: '0 auto', width: isMobile() && !isTablet() ? '100%' : '75%'}}>
            <div style={{position:"absolute",right:"5px",top:"2px"}} onClick={this.toggleVisibility}>
                <img
                    src={CdnPath("frontend/X.svg")}
                    style={{ height: isTablet() ? '16px' : '33px' }}/>
            </div>

            {this.renderFiltersAppliedLines()}
        </div>
    }

    render() {
        const displayStyle = { display: this.state.visible ? 'flex' : 'none' }

        if ( !FILTERS_PER_TYPE[this.props.itemType] ) {
            return null
        }
        return <div ref={this.mainDiv} id={"recent-deals-filters"} style={this.calcMainDivHeight()}>
            { this.state.visible ? this.renderXline() : this.renderSearchButton() }
            <Grid
                container
                spacing={isTablet() ? 4 : 0}
                style={
                    isTablet()
                        ? { width: '80%', margin: '0 auto', ...displayStyle }
                        : displayStyle
                }
            >
                {!this.state.hiddenFilters && FILTERS_PER_TYPE[this.props.itemType].map((e,i) => (
                    <Grid item xs={12} sm={6} md={6} key={i} >
                        {
                            React.createElement(e,{
                                visible: this.state.visible,
                                itemType: this.props.itemType,
                                route:"recent_deals_"+this.props.itemType,
                                setFilters:this.setFilters,
                                storagePrefix: LOCAL_STORAGE_PREFIX,
                                storage: RDStorage,
                                itemFilters: this.props.itemFilters
                            })
                        }
                    </Grid>)
                )}
            </Grid>
            {!this.state.visible ? this.renderTagLine() :
                <div onClick={this.toggleVisibility}
                     style={{backgroundColor: '#2D5DEC', padding: '9px 30px', color: '#fff', margin:"0px 10px",borderRadius:"8px",textAlign:"center",font: '500 20px Roboto', display: isTablet() ? 'none' : 'block'}}>Done</div> }
        </div>
    }
}

export default RecentDealsFilters;